/**
 * @fileoverview Role codes the Invite User form treats specially.
 * @description The backend lets a Sales role (and only a Sales role) carry a reporting manager:
 * required for Sales Manager and Sales Executive, optional for Sales Head (it then reports to
 * the inviting Super Admin), and refused with 400 / 0001 for every other role. The Sales role
 * codes themselves are shared (shared/constants/sales-role-codes.constants.ts).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

/** Roles whose reporting manager is required. */
export const MANAGER_REQUIRED_ROLE_CODES: ReadonlySet<string> = new Set([
  'SALES_MANAGER',
  'SALES_EXECUTIVE',
])

/** India's dialling code — this app's mobile field only accepts Indian numbers. */
export const INVITE_COUNTRY_CODE = '+91'
